module ds_cluster_ui {

   angular.module("com.vmware.vsphere.client.dsCluster")
         .constant("dsClusterHelpConstants", {
            SDRS_FAULT_TROUBLESHOOT_GUIDE_ID: "vc_304"
         });
}
